// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2lgkF","label":"Button_label__1sAJn"};